import * as React from 'react'
import type {SVGProps} from 'react'
const SvgTooltipDanderSolid = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={12}
        height={12}
        fill="none"
        stroke="#CD3C5E"
        viewBox="0 0 12 12"
        {...props}
    >
        <circle cx={6} cy={6} r={4.5} />
        <path strokeLinejoin="round" d="M5.8 3.6h.4L6 6.5z" />
        <circle cx={6} cy={8.2} r={0.6} fill="#CD3C5E" stroke="none" />
    </svg>
)
export default SvgTooltipDanderSolid
